<template>
  <div class="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2" style=" height: 100vh;">
    <div class="order-1 order-sm-2">
      <p class="m-0 fs-1 fw-bold">Oops...</p>
      <p class="m-0 fs-4">{{ $t('errorConElServidor') }}</p>
      <button type="button" @click="recargar()" class="btn btn-primary mt-2">{{ $t('recargar') }}</button>
    </div>
    <img src="../assets/errorServerGoethe.png" alt="ErrorGoethe" class="img-responsive order-2 order-sm-1" style="width: 40vw;max-width: 400px; height: auto;" />
  </div>
</template>

<script>
import { onMounted, ref, onUnmounted} from 'vue';
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: "ErrorServer",
  setup() {
    const { t } = useI18n();
    const message = ref('You are not logged in!');
    const imageUrl = ref(''); // For storing the image URL
    const router = useRouter();
    
    let pollingTimeoutId = null;
    const pollIntervals = ref([2000, 5000]);

    const isTokenValid = () => {
      const token = localStorage.getItem('authToken')
      if (!token) return false;

      try {
        const [, payloadBase64] = token.split('.');
        const payload = JSON.parse(atob(payloadBase64));
        const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
        console.log('currenttime:'+currentTime)
        console.log('payload:'+payload.exp)
        return payload.exp > currentTime; // Comparar el tiempo de expiración
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        return false;
      }
    };

    const recargar = async  () => {
      const redirect = localStorage.getItem('redirectAfterLogin')
      console.log(redirect)
      if(redirect){
        //localStorage.removeItem('redirectAfterLogin');
        await router.push(redirect);
      }else {
        // Un fallback por si no hay redirect
        await router.push('/'); 
      }
    };


    // Declaramos startPolling ANTES de checkConnection
    let startPolling;

    const checkConnection = async () => {
      try {
        console.log('Chequeando conexión...'); // Log de chequeo
        
        if (!navigator.onLine) {
          console.log('Navegador detecta sin conexión. Esperando...');
          // ¡IMPORTANTE! Volvemos a programar el chequeo
          startPolling();
          return;
        }

        await api.options('/api/Account/refresh');
        
        console.log('¡Conexión reestablecida! (Respuesta 200 OK)');
        // NO volvemos a programar. Limpiamos por si acaso.
        if (pollingTimeoutId) clearTimeout(pollingTimeoutId);
        await recargar();

      } catch (error) {
        if (error.response) {
          console.log(`¡Conexión reestablecida! (Servidor respondió con ${error.response.status})`);
          // NO volvemos a programar. Limpiamos por si acaso.
          if (pollingTimeoutId) clearTimeout(pollingTimeoutId);
          await recargar();

        } else {
          console.log('El servidor sigue sin responder (error de red). Se reintentará...');
          // ¡IMPORTANTE! Volvemos a programar el chequeo
          startPolling();
        }
      }
    };

    // 3. Nueva función para manejar el polling recursivo
    startPolling = () => {
      // Saca el primer tiempo de la lista.
      // .value porque es un ref (aunque podrías quitar el ref)
      const interval = pollIntervals.value.shift();

      // Si 'interval' es undefined (lista vacía), usamos 10s.
      // Si no, usamos el valor de 'interval' (2s la 1ra vez, 5s la 2da).
      const nextInterval = interval || 10000;
      
      console.log(`Siguiente chequeo en ${nextInterval / 1000} segundos.`);

      // Guardamos el ID del timeout para poder cancelarlo
      pollingTimeoutId = setTimeout(checkConnection, nextInterval);
    };

    // 4. Limpiamos el temporizador al desmontar
    onUnmounted(() => {
      if (pollingTimeoutId) {
        clearTimeout(pollingTimeoutId);
      }
    });

    // 5. En onMounted, solo iniciamos el polling
    onMounted(async () => {
      // Inicia el ciclo de polling
      startPolling();

      console.log('Temporizador de chequeo progresivo iniciado.');

      // ... (tu lógica de lastUpdate y isTokenValid sin cambios) ...
       const lastUpdate = localStorage.getItem("lastUpdate");
       const today = new Date().toISOString().split("T")[0]; 

       if (lastUpdate !== today) {
         localStorage.setItem("lastUpdate", today);
         window.location.reload(); 
       }

       if (isTokenValid()) {
         console.log('El token es válido.');
       }
    });

    return {
      message,
      imageUrl,
      t,
      recargar,
    }
  }
}
</script>

<style scoped>
</style>